export default "__VITE_ASSET__CBgAHIms__"